<div class="container-fluid">
    <div style="display: flex; justify-content: space-between; align-items: center;">
        <span>
            <span class="rm-title rm-title-3">Admin Direct Marketing</span>
            <br/>
            <span class="rm-title rm-title-6 rm-lighter">This is where you can edit the deal card information based on deal state.</span>
        </span>
        <button mat-raised-button color="primary" (click)="createCampaign()">Create New Campaign</button>
    </div>
    <!-- <div class="mt-4">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dolores amet quod recusandae eum vel quam fugiat? Unde harum obcaecati mollitia tempore fuga! Vel numquam non, laborum iusto commodi tenetur molestias nemo doloribus, quos ea voluptate voluptates earum incidunt maxime officiis saepe natus blanditiis molestiae? In veniam ex nostrum nam possimus!
    </div> -->
    <div class="mt-4">
        <table mat-table [dataSource]="dataSource" style="width: 100%;" class="mat-elevation-z8 mt-4">

            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef> Recipient </th>
                <td mat-cell *matCellDef="let element">
                    <div style="display: flex; align-items: center; gap: 8px;">
                        <!-- <mat-icon>person</mat-icon> -->
                        <span class="date-stacked">
                            <span>{{element.recipient.firstName}} {{element.recipient.lastName}} </span>
                            <span>{{element.recipient.email}}</span>
                        </span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="deals">
                <th mat-header-cell *matHeaderCellDef> Deals </th>
                <td mat-cell *matCellDef="let element"> {{element.dealIds?.length || 0 }} </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status}} </td>
            </ng-container>


            <ng-container matColumnDef="lastAction">
                <th mat-header-cell *matHeaderCellDef> Last Action </th>
                <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.lastActionTimestamp | date : 'mediumDate' }}</span>
                      <span>{{ element.lastActionTimestamp | date : 'shortTime' }}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="createdBy">
                <th mat-header-cell *matHeaderCellDef> Created By </th>
                <td mat-cell *matCellDef="let element"> {{element.createdBy.firstName}} {{element.createdBy.lastName}} </td>
            </ng-container>

            <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef> Created </th>
                <td mat-cell *matCellDef="let element">
                    <div class="date-stacked">
                      <span>{{ element.created | date : 'mediumDate' }}</span>
                      <span>{{ element.created | date : 'shortTime' }}</span>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" *ngIf="element.status != 'DRAFT'" title="View Analytics" (click)="viewCampaign(element)"><mat-icon>analytics</mat-icon></button>
                    <button mat-icon-button color="primary" *ngIf="element.status == 'DRAFT'" title="Edit Campaign" (click)="editCampaign(element)"><mat-icon>edit</mat-icon></button>
                    <button mat-icon-button color="warn" *ngIf="element.status == 'DRAFT'" title="Delete Campaign" (click)="deleteCampaign(element)"><mat-icon>delete</mat-icon></button>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>

